import { gql } from '@apollo/client';
import Fragments from './fragments';

export const DOCUMENT_SYNC_STATE_UPDATED = gql`
  subscription documentSyncStateUpdated($id: Int) {
    documentSyncStateUpdated(id: $id) {
      documentSyncState {
        ...documentSyncState
      }
    }
  }
  ${Fragments.documentSyncState}
`;

export const DOCUMENT_SYNC_STATE_DELETED = gql`
  subscription documentSyncStateDeleted($id: Int!) {
    documentSyncStateDeleted(id: $id) {
      documentSyncStateId
    }
  }
`;
